import PropTypes from 'prop-types';
import React from "react";
import {generateUrl, cleanChartConf} from "../lib/history";
import autobind from "autobind-decorator";
import {connect} from "react-redux";

import TriggerMixin from "./Modal.jsx";

import "./ShareModal.css";

@connect(state => ({
    charts: state.charts
}), null, null, {withRef: true})
class ShareModal extends TriggerMixin {
    static defaultProps = {
        title: "Share",
        chart: {}
    };

    static propTypes = {
        current: PropTypes.object.isRequired,
        charts: PropTypes.array.isRequired
    };

    static displayName = 'ShareModal';

    shouldComponentUpdate() {
        return this.isOpen();
    }

    @autobind
    onShow() {
        this.forceUpdate(() => {
            this.urlRef.focus();
            this.urlRef.select();
        });
    }

    renderContent() {
        let props = {
            readOnly: true,
            onClick: e => e.target.select()
        };

        let {current, charts} = this.props;

        current = cleanChartConf(current);
        charts = charts.map(cleanChartConf);

        let chartUrl = generateUrl({charts: [current], exposed: false}).toString();

        let format = obj => JSON.stringify(obj, null, "    ");

        return (
            <div className="share">
                <div className="item">
                    <legend>URL for current chart</legend>
                    <input className="url" ref={el => this.urlRef = el} value={chartUrl} {...props}/>
                </div>
                <div className="item">
                    <legend>Config for current chart</legend>
                    <textarea className="current" ref={el => this.currentRef = el} value={format(current)} {...props}/>
                </div>
                <div className="item">
                    <legend>Config for all charts</legend>
                    <textarea className="all" ref={el => this.allRef = el} value={format(charts)} {...props} />
                </div>
            </div>
        );
    }
}

export default ShareModal;


// WEBPACK FOOTER //
// ./src/kpi/components/ShareModal.jsx